









































import { Vue, Component, VModel, Prop } from 'vue-property-decorator';

@Component({})
export default class ToggleButton extends Vue {
  @VModel({ type: Boolean, required: true, default: false }) state!: boolean

  @Prop({ type: String, default: '24px', required: false }) height!: string

  @Prop({ type: Boolean, required: false, default: false }) disabled!: boolean

  @Prop({ type: String, required: false }) uncheckedTitle!: string

  @Prop({ type: String, required: false }) checkedTitle!: string

  isActive(stateToCompare: boolean) {
    return this.state === stateToCompare ? 'rgba(var(--a-primary), 1)' : ''
  }
}
